export default __webpack_public_path__ + "static/media/ARM.08305278.svg";